/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_FInputs */

const cs_enum_f = /** @type {(inputs: Enum_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F`)
};

const en_enum_f = /** @type {(inputs: Enum_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F`)
};

/**
* | output |
* | --- |
* | "F" |
*
* @param {Enum_FInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_f = /** @type {((inputs?: Enum_FInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_FInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_f(inputs)
	return cs_enum_f(inputs)
});